export const isValidTimeZone = (tz: string): boolean => {
	try {
		// Intl.DateTimeFormat will throw an error if the timeZone is invalid
		Intl.DateTimeFormat(undefined, { timeZone: tz });
		return true;
	} catch (e) {
		return false;
	}
};
